import { createSelector } from 'reselect';
import { freeShippingCopyPDPSelector } from 'selectors/testTarget/offers/freeShippingCopyPDP/freeShippingCopyPDPSelector';

const activeSelector = createSelector(freeShippingCopyPDPSelector, freeShippingCopyPDP => !!freeShippingCopyPDP.active);

export { activeSelector };
